<!--
 * @Author: yuanjianlong
 * @Description: 组件展示
 * @Date: 2021-12-01 11:19:24
 * @LastEditTime: 2021-12-14 15:46:03
 * @FilePath: /teacher-h5/src/demo/input.vue
-->
<template>
  <div class="h-full p-20 bg-gray-10">
    <div>
      <h1 class="text-h32 mb-20">
        Input 输入框1
      </h1>
      <div>
        <div class="mb-20">
          <a-input placeholder="Basic usage" />
        </div>

        <div class="mb-20">
          <a-input placeholder="Basic usage" disabled />
        </div>

        <div class="mb-20">
          <a-textarea placeholder="Autosize height based on content lines" auto-size />
          <div style="margin: 24px 0" />
          <a-textarea
            placeholder="Autosize height with minimum and maximum number of lines"
            :auto-size="{ minRows: 2, maxRows: 6 }"
          />
          <div style="margin: 24px 0" />
          <a-textarea
            v-model="value"
            placeholder="Controlled autosize"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </div>

        <div class="mb-20">
          <a-input-search
            placeholder="input search text"
            enter-button="Search"
            size="large"
            @search="onSearch"
          />
        </div>
        <div class="mb-20">
          <a-input-search ref="userNameInput" v-model="userName" placeholder="Basic usage" enter-button="Search">
            <i slot="prefix" class="iconfont icon-search" />
          </a-input-search>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods() {}
}
</script>

<style>
.mb-20 {
  margin-bottom: 20px;
}
</style>